export class LojistikIrsaliyeKalemMiktarOnaylanan {

    tarih: Date;
    irsaliyeNo: string;
    cari: string;
    tasimaci: string;
    stokKodu: string;
    stokAdi: string;
    irsaliyeMiktar: number;
    kabulMiktar: number;
    fazlaMiktar: number;
    redMiktar: number;
    eksikMiktar: number;

    id: number;
    onaylananMiktar: number;
    durum: number;
    aciklama: string;
    
    constructor(obj?: any) {
        if (obj == null) {
            return;
        }
        Object.assign(this, obj);
    }
}
